import { qtyProxy } from "../../../../";
import { IPrintAreas } from "../type";

export const CanvasEditor = (defaultSelectedTechniques: IPrintAreas) => {
  const canvasHtml = defaultSelectedTechniques
    .map(
      (_, index) => `<div class="canvas-editor-wrapper ${index === qtyProxy["selectedPositionIndex"] ? "show" : "hide"}">
        <canvas class="${index === qtyProxy["selectedPositionIndex"] ? "show" : "hide"}"  id="productCanvas${index}" width="500" height="500"></canvas>    </div>`
    )
    .join("");

  return `
        <section class="product-canvas">
                ${canvasHtml}
        </section>
    `;
};
